import React, { Component } from 'react';
import classnames from "classnames";
import fire from "views/pages/firebaseConfig.js";
import * as firebase from 'firebase/app';
import 'firebase/auth';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardImg,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";




class Login extends Component {
    state = {
        squares1to6: "",
        squares7and8: ""
      };
      componentDidMount() {
        document.body.classList.toggle("register-page");
        document.documentElement.addEventListener("mousemove", this.followCursor);
      }
      componentWillUnmount() {
        document.body.classList.toggle("register-page");
        document.documentElement.removeEventListener(
          "mousemove",
          this.followCursor
        );
      }
      followCursor = event => {
        let posX = event.clientX - window.innerWidth / 2;
        let posY = event.clientY - window.innerWidth / 6;
        this.setState({
          squares1to6:
            "perspective(500px) rotateY(" +
            posX * 0.05 +
            "deg) rotateX(" +
            posY * -0.05 +
            "deg)",
          squares7and8:
            "perspective(500px) rotateY(" +
            posX * 0.02 +
            "deg) rotateX(" +
            posY * -0.02 +
            "deg)"
        });
      };

  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.signup = this.signup.bind(this);
    this.state = {
      email: '',
      password: ''
    };
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  login(e) {
    e.preventDefault();
    fire.auth().signInWithEmailAndPassword(this.state.email, this.state.password).then((u)=>{
    }).catch((error) => {
        console.log(error);
      });
  }

  signup(e){
    e.preventDefault();
    fire.auth().createUserWithEmailAndPassword(this.state.email, this.state.password).then((u)=>{
    }).then((u)=>{console.log(u)})
    .catch((error) => {
        console.log(error);
      })
  }
  handleLogin() {
    var provider = new firebase.auth.FacebookAuthProvider();
    firebase
      .auth()
      .signInWithRedirect(provider)
      ;
  }
  
  handleLogin1() {
    var provider = new firebase.auth.GithubAuthProvider();
    firebase
      .auth()
      .signInWithRedirect(provider)
      ;
  }
  handleLogin2() {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithRedirect(provider)
      ;
  }


  
  render() {
    return (
        <>
          <IndexNavbar />
          <div className="wrapper">
            <div className="page-header">
              <div className="page-header-image" />
              <div className="content">
                <Container>
                  <Row>
                    <Col className="offset-lg-0 offset-md-3" lg="5" md="6">
                      <div
                        className="square square-7"
                        id="square7"
                        style={{ transform: this.state.squares7and8 }}
                      />
                      <div
                        className="square square-8"
                        id="square8"
                        style={{ transform: this.state.squares7and8 }}
                      />
                      <Card className="card-register">
                        <CardHeader>
                          <CardImg
                            alt="..."
                            src={require("assets/img/square-purple-1.png")}
                          />
                          <CardTitle tag="h4">Signin</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <Form className="form"  >
                            
                            <InputGroup
                              className={classnames({
                                "input-group-focus": this.state.emailFocus
                              })}
                            >
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="tim-icons icon-email-85" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                placeholder="Email"
                                type="email"
                                name="email"
                                value={this.state.email}
                                onChange={this.handleChange}
                                onFocus={e => this.setState({ emailFocus: true })}
                                onBlur={e => this.setState({ emailFocus: false })}
                              />
                            </InputGroup>
                            <InputGroup
                              className={classnames({
                                "input-group-focus": this.state.passwordFocus
                              })}
                            >
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="tim-icons icon-lock-circle" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                placeholder="Password"
                                type="password"
                                name="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                                onFocus={e =>
                                  this.setState({ passwordFocus: true })
                                }
                                onBlur={e =>
                                  this.setState({ passwordFocus: false })
                                }
                              />
                            </InputGroup>
                            <FormGroup check className="text-left">
                              <Label check>
                                <Input type="checkbox" />
                                <span className="form-check-sign" />I agree to the{" "}
                                <a
                                  href="#pablo"
                                  onClick={e => e.preventDefault()}
                                >
                                  terms and conditions
                                </a>
                                .
                              </Label>
                            </FormGroup>
                          </Form>
                        </CardBody>&nbsp;&nbsp;
                        
                        <div className="btn-wrapper text-center">
                  <Button
                    className="btn-neutral btn-icon"
                    color="default"
                    href="#pablo"
                    onClick={this.handleLogin1}
                  >
                    <img alt="..." src={require("assets/img/github.svg")} />
                  </Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Button
                    className="btn-neutral btn-icon"
                    color="default"
                    href="#pablo"
                    onClick={this.handleLogin}
                  >
                    <img alt="..." src={require("assets/img/facebook.svg")} />
                  </Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Button
                    className="btn-neutral btn-icon"
                    color="default"
                    href="#pablo"
                    onClick={this.handleLogin2}
                  >
                    <img alt="..." src={require("assets/img/google.svg")} />
                  </Button>
                </div>
               
                <Form role="form">
                  <div className="text-center">
                      <CardFooter>
                    <Button className="my-4" color="primary"  type="button" onClick={this.login}>
                      Sign in
                    </Button>
                    </CardFooter>
                  </div>
                </Form>
                      </Card>
                    </Col>
                  </Row>
                  <div className="register-bg" />
                  <div
                    className="square square-1"
                    id="square1"
                    style={{ transform: this.state.squares1to6 }}
                  />
                  <div
                    className="square square-2"
                    id="square2"
                    style={{ transform: this.state.squares1to6 }}
                  />
                  <div
                    className="square square-3"
                    id="square3"
                    style={{ transform: this.state.squares1to6 }}
                  />
                  <div
                    className="square square-4"
                    id="square4"
                    style={{ transform: this.state.squares1to6 }}
                  />
                  <div
                    className="square square-5"
                    id="square5"
                    style={{ transform: this.state.squares1to6 }}
                  />
                  <div
                    className="square square-6"
                    id="square6"
                    style={{ transform: this.state.squares1to6 }}
                  />
                </Container>
              </div>
            </div>
            <Footer />
          </div>
        </>
      );
  }
}
export default Login;